import { useStyles } from '@hooks/useStyles'
import { useWizardContext } from '@pages/Landings/routes/Landings/CreateLandingWizard/contexts'
import { Button, Heading, Paragraph, Spacer } from '@ui-kit'
import { BoxOutline, BoxOutlineProvider } from '@ui-kit/BoxOutline'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import styles from './common.module.scss'

const tones = [
  'professional',
  'casual',
  'humorous',
  'friendly',
  'helpful',
  'informative',
  'convincing'
]

const NinthStep: React.FC = () => {
  const { t } = useTranslation()

  const {
    formik,
    validators: { isNinthStepValid },
    submit,
    setShouldGenerateContent
  } = useWizardContext()
  const { values, setFieldValue } = formik
  const { contentTone } = values

  const boxOutlineStyles = useStyles({
    [styles.panel]: true
  })

  const boxOutlineContainerStyles = useStyles({
    [styles.container]: true
  })

  return (
    <Column>
      <Heading level={1} weight={600}>
        {t('composer.content.ai.generation.tone.title')}
      </Heading>

      <Spacer space={20} />

      <Paragraph size={14} color='neutral-6'>
        {t('composer.content.ai.generation.tone.description')}
      </Paragraph>

      <Spacer space={20} />

      <Row className={styles['tones-container']} wrap>
        {tones.map(tone => {
          const handleClick = () => setFieldValue('contentTone', tone)

          return (
            <BoxOutlineProvider
              key={tone}
              controlledActive={contentTone === tone}
            >
              <BoxOutline
                onClick={handleClick}
                className={boxOutlineStyles}
                containerClassName={boxOutlineContainerStyles}
                padding={15}
              >
                {t(`composer.content.ai.generation.tone.${tone}`)}
              </BoxOutline>
            </BoxOutlineProvider>
          )
        })}
      </Row>

      <Spacer space={30} />

      <Row justifyContent='end'>
        <Button
          icon='icon-arrow-right'
          disabled={!isNinthStepValid}
          onClick={() => {
            setShouldGenerateContent(true)
            submit({ isGeneratePossible: true, shouldGenerateContent: true })
          }}
        >
          {t('landings.create.wizard.landing.modal.finish')}
        </Button>
      </Row>

      <Spacer space={30} />
    </Column>
  )
}

export default NinthStep
